import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract, AuthenticationGuard } from '@app/core';
import { Shell } from '@app/shell/shell.service';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { WhatsappBotComponent } from './whatsapp-bot/whatsapp-bot.component';
import { WhatsappBotGuard } from '@app/core/whatsapp-bot.guard';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'client/:clientId/whatsapp-bot',
      component: WhatsappBotComponent,
      canActivate: [NgxPermissionsGuard, WhatsappBotGuard],
      data: {
        title: 'Whatsapp Bot',
        breadcrumb: 'Whatsapp-Bot',
        permissions: {
          only: ['admin', 'manageStaff', 'myEntry'],
          redirectTo: {
            navigationCommands: ['403'],
            navigationExtras: {
              replaceUrl: false
            }
          }
        }
      }
    }
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class WhatsappBotRoutingModule {}
